import { IValidationRule } from "@/types"

const invoiceValidationRules: { [s: string]: IValidationRule } = {
    costCategory: {
        required: true
    },
    invoiceDate: {
        required: true
    },
    invoiceNumber: {
        required: true
    },
    invoiceAmount: {
        required: true,
        type: "decimal",
        nonZero: true,
    },
    invoiceForeignCurrencyAmount: {
        required: true,
        type: "decimal",
        nonZero: true,
    },
    invoiceForeignCurrency: {
        required: true
    },
    discountPercentage: {
        required: true,
        type: "decimal",
        min: 0,
        max: 99.99,
    },
    referenceNumber: {
        required: true
    }
}

export default invoiceValidationRules
